module.exports = __webpack_public_path__ + "img/discover.adc5f184.svg";